module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_Pepita_Amarilla.f2e1775b.pdf";